import { render, staticRenderFns } from "./NuevoPedido.vue?vue&type=template&id=5903d93c&scoped=true"
import script from "./NuevoPedido.vue?vue&type=script&lang=js"
export * from "./NuevoPedido.vue?vue&type=script&lang=js"
import style0 from "./NuevoPedido.vue?vue&type=style&index=0&id=5903d93c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5903d93c",
  null
  
)

export default component.exports